// Remove any characters which are not numeric digits
const parseNumber = number => number.replace(/\D/g, '');

export default parseNumber;
